import { render, staticRenderFns } from "./ItemsRentUpdate.vue?vue&type=template&id=0968fdb0&scoped=true&"
import script from "./ItemsRentUpdate.vue?vue&type=script&lang=js&"
export * from "./ItemsRentUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ItemsRentUpdate.vue?vue&type=style&index=0&id=0968fdb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0968fdb0",
  null
  
)

export default component.exports